import { 
    Popover, 
} from '@mui/material'
import { Demodal, useModal } from "demodal";
import { muiDialog } from 'demodal/material-ui'




export const CustomTooltip = Demodal.create(
    (
        {message, anchor}:{message: string, anchor:Element, direction: 'left' | 'center' | 'right' }
    ) => {

    const customTooltip = useModal()

    return (
        <Popover
            {...muiDialog(customTooltip)}
            
            anchorEl={anchor}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }} 
        >
            <div 
                style={{ 
                    color: 'white', 
                    padding: '5px', 
                    backgroundColor: 'rgb(50,50,50)', 
                    border: '1px solid white', 
                    borderRadius: '6px', 
                    maxWidth:'400px',
                    filter: 'drop-shadow(0px 0px 3px black)'
                }}
            >
                { message }
            </div>
        </Popover>
    )
})

